/**
 * CSS property-name conversion. A leaf module with no imports so any surface
 * can take it without pulling the ad-studio model chain along — including the
 * Remotion renderer bundle.
 */

/**
 * `background-color` → `backgroundColor`, `-webkit-line-clamp` →
 * `WebkitLineClamp`. Vendor prefixes capitalize the first segment; everything
 * else is plain camelCase. Custom properties (`--foo`) are passed through
 * verbatim — React sets those via `setProperty` and must see the raw name.
 */
export function cssPropertyToReactKey(property: string): string {
  if (property.startsWith("--")) return property;
  if (property.startsWith("-")) {
    const camel = kebabToCamel(property.slice(1));
    return camel.charAt(0).toUpperCase() + camel.slice(1);
  }
  return kebabToCamel(property);
}

function kebabToCamel(value: string): string {
  return value.replace(/-([a-z])/g, (_, c: string) => c.toUpperCase());
}
